// Dispara um evento do pixel
function dispatchPixelEvent(service, eventName, eventParams = {}) {
  let pxEventDispatched = false;
  if (!previewMode) {
    // AddToCart
    if (eventName === 'AddToCart') {
      // Facebook
      if (service === 'facebook' && typeof fbq === 'function') {
        const pixels = $('#infos-base').data('fb-pixels');
        const fbclid = $('#infos-base').data('fbclid');
        if (pixels && Object.keys(pixels).length > 0) {
          Object.keys(pixels).forEach((i) => {
            const px = pixels[i];
            const pxId = px.pixel_id;
            const pxEvent = 'AddToCart';
            const pxEventId = generateToken();
            const pxInfos = eventParams;
            if (px.processing_mode == 'api') {
              setTimeout(() => {
                dispatchAddToCartAPI({
                  id: pxId,
                  event: pxEvent,
                  event_id: pxEventId,
                  token: px.fb_token,
                  fbclid: fbclid,
                  infos: pxInfos,
                });
              }, 500);
            }
            fbq('trackSingle', '' + pxId + '', pxEvent, pxInfos, { eventID: pxEventId });
          });
        }
        pxEventDispatched = true;
      }
    }
    if (pxEventDispatched) {
      console.log(`Pixel (${service}): '${eventName}' disparado.`);
    }
  }
}

// Dispara a ação para acionar o evento 'AddToCart' do Facebook (Via API)
function dispatchAddToCartAPI(pixel) {
  const urlAction = urlBase + 'core/acoes/checkout/facebook_pixel_addtocart.php';
  $.ajax({
    url: urlAction,
    type: 'POST',
    data: {
      pixel_id: pixel.id,
      event_id: pixel.event_id,
      pixel_infos: pixel.infos,
      pixel_token: pixel.token,
      fbclid: pixel.fbclid,
      pag_url: window.location.origin + window.location.pathname,
    },
  })
    .done(function (result) {
      if (result != 'success') {
        console.log('Facebook Pixel API Error: ' + result);
      }
    })
    .fail(function (jqXHR, textStatus, error) {
      console.log(error);
    });
}

// Dispara o evento 'add_to_cart' do Google Analytics
function dispatchAddToCartAnalytics() {
  /*window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: 'BRL',
      value: Number(curVariant.sale_price),
      items: [
        {
          item_id: curVariant.sku,
          item_name: curVariant.product_title,
          currency: 'BRL',
          price: Number(curVariant.sale_price),
          quantity: Number($('#quantity').val()),
        },
      ],
    },
  });*/
  if (typeof gtag !== 'undefined') {
    let qty = $('#quantity').val() ? Number($('#quantity').val()) : 1;
    gtag('event', 'add_to_cart', {
      currency: 'BRL',
      value: Number(curVariant.sale_price) * qty,
      items: [
        {
          item_id: curVariant.sku,
          item_name: curVariant.product_title,
          currency: 'BRL',
          price: Number(curVariant.sale_price),
          quantity: qty,
        },
      ],
    });
  } else if (typeof dataLayer !== 'undefined') {
    dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'BRL',
        value: Number(curVariant.sale_price) * qty,
        items: [
          {
            item_id: curVariant.sku,
            item_name: curVariant.product_title,
            currency: 'BRL',
            price: Number(curVariant.sale_price),
            quantity: qty,
          },
        ],
      },
    });
  }
}

// Dispara o evento 'AddToCart' do Pinterest
function dispatchAddToCartPinterest() {
  if (typeof pintrk !== 'undefined') {
    pintrk('track', 'addtocart', {
      value: Number(curVariant.sale_price) * Number($('#quantity').val()),
      currency: 'BRL',
      line_items: [
        {
          product_id: curVariant.sku,
          product_name: curVariant.product_title,
          product_price: Number(curVariant.sale_price),
          product_quantity: Number($('#quantity').val()),
          product_category: '',
        },
      ],
    });
  }
}

// Dispara o evento 'AddToCart' do Tiktok
function dispatchAddToCartTiktok() {
  if (typeof ttq !== 'undefined') {
    ttq.track('AddToCart', {
      contents: [
        {
          content_id: curVariant.sku,
          content_name: curVariant.product_title,
          quantity: Number($('#quantity').val()),
          price: Number(curVariant.sale_price),
        },
      ],
      content_type: 'product',
      value: Number(curVariant.sale_price) * Number($('#quantity').val()),
      currency: 'BRL',
    });
  }
}

// Dispara o evento 'AddToCart' do Kwai
function dispatchAddToCartKwai() {
  if (typeof kwaiq !== 'undefined') {
    kwaiq.track('addToCart');
  }
}

// Dispara o evento 'AddToCart' da Outbrain
function dispatchAddToCartOutbrain() {
  if (typeof obApi !== 'undefined') {
    obApi('track', 'AddToCart');
  }
}
